import React from 'react';
import { Redirect, Switch, Route, useLocation } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/common/ErrorBoundary';
import ProfileCompletenessGuard from './components/auth/ProfileCompletenessGuard';
import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import VolunteerPage from './pages/VolunteerPage';
import JoinUsPage from './pages/JoinUsPage';
import DonationsPage from './pages/DonationsPage';
import ServicesPage from './pages/ServicesPage';
import ServiceTherapiesPage from './pages/ServiceTherapiesPage';
import ServiceDirectAppointmentsPage from './pages/ServiceDirectAppointmentsPage';
import SubscriptionsPage from './pages/SubscriptionsPage';
import BlogPage from './pages/BlogPage';
import RegisterPage from './pages/RegisterPage';
import CreateAccountPage from './pages/CreateAccountPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import AgendaBookingPage from './pages/AgendaBookingPage';
import AgendaCalendarPage from './pages/AgendaCalendarPage';
import AgendaPaymentPage from './pages/AgendaPaymentPage';
import AgendaStripeReturnPage from './pages/AgendaStripeReturnPage';
import AgendaReceiptPage from './pages/AgendaReceiptPage';
import InformesPage from './pages/InformesPage';
import ProfilePage from './pages/ProfilePage';
import ProfilePatientsPage from './pages/ProfilePatientsPage';
import ProfileNotificationsPage from './pages/ProfileNotificationsPage';
import ProfileChangePasswordPage from './pages/ProfileChangePasswordPage';
import ProfileSubscriptionsPage from './pages/ProfileSubscriptionsPage';
import ProfileLanguagePage from './pages/ProfileLanguagePage';
import ProfileTermsPage from './pages/ProfileTermsPage';
import ProfileFichaPage from './pages/ProfileFichaPage';
import CompleteProfilePage from './pages/CompleteProfilePage';
import AdminNominaPage from './pages/AdminNominaPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminPatientsPage from './pages/AdminPatientsPage';
import AdminInventoryPage from './pages/AdminInventoryPage';
import AdminConfiguracionPage from './pages/AdminConfiguracionPage';
import AdminMontosEstudioPage from './pages/AdminMontosEstudioPage';
import AdminDescuentosPage from './pages/AdminDescuentosPage';

const PaginaInicio = () => {
  const location = useLocation();
  const search = location.search || '';

  if (search.indexOf('session_id=') !== -1 || search.indexOf('resultado=') !== -1) {
    return <AgendaStripeReturnPage />;
  }

  return <HomePage />;
};

const App = () => {
  return (
    <ErrorBoundary>
      <MainLayout>
        <ScrollToTop />
        <ProfileCompletenessGuard>
          <Switch>
          <Route exact path="/" component={PaginaInicio} />
          <Route path="/about" component={AboutPage} />
          <Route path="/programs">
            <div>Programas - En construcción</div>
          </Route>
          <Route path="/subscriptions" component={SubscriptionsPage} />
          <Route path="/blog" component={BlogPage} />
          <Route path="/registro/crear-cuenta" component={CreateAccountPage} />
          <Route path="/recuperar-contraseña/restablecer" component={ForgotPasswordPage} />
          <Route path="/recuperar-contraseña" component={ForgotPasswordPage} />
          <Route path="/registro" component={RegisterPage} />
          <Route path="/iniciar-sesion" component={RegisterPage} />
          <Route path="/completar-perfil" component={CompleteProfilePage} />
          <Route path="/admin/inventario" component={AdminInventoryPage} />
          <Route path="/admin/nomina" component={AdminNominaPage} />
          <Route exact path="/admin/configuracion" component={AdminConfiguracionPage} />
          <Route path="/admin/configuracion/montos" component={AdminMontosEstudioPage} />
          <Route path="/admin/configuracion/descuentos" component={AdminDescuentosPage} />
          <Route path="/admin/usuarios" component={AdminUsersPage} />
          <Route path="/admin/pacientes" component={AdminPatientsPage} />
          <Route path="/services/terapias" component={ServiceTherapiesPage} />
          <Route path="/services/citas-directas" component={ServiceDirectAppointmentsPage} />
          <Route path="/services" component={ServicesPage} />
          <Route path="/contact">
            <div>Contacto - En construcción</div>
          </Route>
          <Route path="/volunteer" component={VolunteerPage} />
          <Route path="/se-parte-de-nosotros" component={JoinUsPage} />
          <Route path="/donations" component={DonationsPage} />
          <Route path="/agenda/calendario" component={AgendaCalendarPage} />
          <Route path="/agenda/recibo/:citaId" component={AgendaReceiptPage} />
          <Route path="/agenda/regreso-pago" component={AgendaStripeReturnPage} />
          <Route path="/agenda/pago" component={AgendaPaymentPage} />
          <Route path="/agenda" component={AgendaBookingPage} />
          <Route path="/informes" component={InformesPage} />
          <Route exact path="/perfil" component={ProfilePage} />
          <Route path="/perfil/pacientes" component={ProfilePatientsPage} />
          <Route path="/perfil/hijos" component={ProfilePatientsPage} />
          <Route path="/perfil/notificaciones" component={ProfileNotificationsPage} />
          <Route path="/perfil/cambiar-contraseña" component={ProfileChangePasswordPage} />
          <Route path="/perfil/planes" component={ProfileSubscriptionsPage} />
          <Route path="/perfil/idioma" component={ProfileLanguagePage} />
          <Route path="/perfil/terminos" component={ProfileTermsPage} />
          <Route
            path="/perfil/privacidad"
            render={() => <Redirect to="/perfil/terminos" />}
          />
          <Route path="/perfil/ficha" component={ProfileFichaPage} />
          <Route path="/perfil/reseña-profesional" render={() => <Redirect to="/perfil/ficha" />} />
        </Switch>
        </ProfileCompletenessGuard>
      </MainLayout>
    </ErrorBoundary>
  );
};

export default App;

